module.exports = __webpack_public_path__ + "img/info_data.a6cc5c1e.svg";